import axiosInstance from "../../../Utils/axios";
import axios from "axios";
let cancelToken;

//obtaining the paginated data
export const getUnit = (postsPerPage) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`api/v1/item/item-unit?offset=0&limit=${postsPerPage}&ordering=-id`, {
    cancelToken: cancelToken.token,
  });
};
//obtaining all fiscal sessions
export const getAllUnit = () => axiosInstance.get(`api/v1/item/item-unit?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageUnit = (number, postsPerPage) =>
  axiosInstance.get(`api/v1/item/item-unit?offset=${(number - 1) * postsPerPage}&limit=${postsPerPage}&ordering=-id`);

//creating function
export const createUnit = (body) => axiosInstance.post(`api/v1/item/item-unit`, body);
//updating function
export const updateUnit = (id, body) => axiosInstance.patch(`api/v1/item/item-unit/${id}`, body);

//searching function
export const handleSearch = (search, postsPerPage) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`api/v1/item/item-unit?offset=0&limit=${postsPerPage}&search=${search}`, {
    cancelToken: cancelToken.token,
  });
};

// checking the redundant data
export const checkRedundantDataUnitName = (e, cancelToken) =>
  axiosInstance.get(`api/v1/item/item-unit?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
